const state = {
  isLoading: false,
  direction: 'forward',
  todoListCount: '0',
  todoUrl: ''
}

// getters 和 组件的 computed 类似，方便直接生成一些可以直接用的数据。当组装的数据要在多个页面使用时，就可以使用 getters 来做
const getters = {
  isLoading: state => state.isLoading,
  direction: state => state.direction,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  // direction: state => state.app.direction,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  refreshdb: state => state.refreshdb.isLoading
}
export {state, getters}



// WEBPACK FOOTER //
// ./src/store/getters.js